import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleTag',
  props: {
    label: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})